import { render, staticRenderFns } from "./PerfilDemografico.vue?vue&type=template&id=7afb7718"
import script from "./PerfilDemografico.vue?vue&type=script&lang=js"
export * from "./PerfilDemografico.vue?vue&type=script&lang=js"
import style0 from "./PerfilDemografico.vue?vue&type=style&index=0&id=7afb7718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports